const stripStyleAttr = (attrs = "") =>
  String(attrs).replace(/\sstyle\s*=\s*("[^"]*"|'[^']*')/gi, "");

export function styleBlogTables(html) {
  if (!html || typeof html !== "string" || !/<table/i.test(html)) {
    return html;
  }

  const unwrapped = html.replace(
    /<div class="azzir-blog-table-wrap"[^>]*>([\s\S]*?)<\/div>/gi,
    "$1",
  );

  return unwrapped.replace(/<table\b[\s\S]*?<\/table>/gi, (tableHtml) => {
    let rowIndex = 0;

    let styled = tableHtml.replace(/<table\b([^>]*)>/i, (_, attrs) => {
      return `<table${stripStyleAttr(attrs)} style="width:100%;border-collapse:collapse;table-layout:fixed;border:1px solid #111">`;
    });

    styled = styled.replace(/<tr\b[^>]*>[\s\S]*?<\/tr>/gi, (trHtml) => {
      const isHeader = rowIndex === 0;
      const dataBg = rowIndex % 2 === 1 ? "#ffffff" : "#f4f1f8";
      const cellStyle = isHeader
        ? "background:#1a1a1a !important;color:#fff !important;border:1px solid #111;padding:10px 12px;font-weight:700;vertical-align:top;word-break:break-word"
        : `background:${dataBg};color:#111;border:1px solid #111;padding:10px 12px;vertical-align:top;word-break:break-word`;
      rowIndex += 1;

      let next = trHtml.replace(/<(td|th)\b([^>]*)>/gi, (_, tag, attrs) => {
        return `<${tag}${stripStyleAttr(attrs)} style="${cellStyle}">`;
      });

      if (isHeader) {
        next = next.replace(/style="color:\s*[^"]+"/gi, 'style="color:#fff"');
      }

      return next;
    });

    return `<div class="azzir-blog-table-wrap" style="width:100%;overflow-x:auto;margin:20px 0 16px">${styled}</div>`;
  });
}
